/** All collections accessible by user in firestore */
enum CollectionNames {
  tokens = "tokens",
  requests = "requests"
}

export default CollectionNames;
